var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CorePanel from "@/prefabs/core/Panel";
import config from "@/config";
var SERVER_STATUS_FORMAT = "%1 ms";
var PanelServerStatus = /** @class */ (function (_super) {
    __extends(PanelServerStatus, _super);
    function PanelServerStatus(scene, x, y) {
        var _this = _super.call(this, scene, x - 10, y - 20) || this;
        _this.text_info = new Phaser.GameObjects.Text(scene, 0, 0, "", {
            color: "white",
            fontFamily: config.graphics.fontFamily,
        })
            .setFontSize(20)
            .setOrigin(1, 0.5);
        _this.add(_this.text_info);
        _this.setDepth(9990);
        _this.setScrollFactor(0);
        return _this;
    }
    PanelServerStatus.prototype.setPing = function (value) {
        var text = Phaser.Utils.String.Format(SERVER_STATUS_FORMAT, [value]);
        this.text_info.setText(text);
    };
    PanelServerStatus.prototype.noConnection = function () {
        this.text_info.setText("No connection!");
    };
    return PanelServerStatus;
}(CorePanel));
export default PanelServerStatus;
